import types from "../../actions/types"

export default function release(state, action) {
  switch (action.type) {
    case types.involve:
      return {
        ...state,
        involved: state.involved + 1,
      }
    /* We access this reducer only if involved > 0 */
    case types.release:
      return {
        ...state,
        involved: state.involved - 1,
      }
    default:
      return state
  }
}
